require('/opt/odin/app/frontend/components/menu/submenu/contest.module.scss');module.exports = "../../app/cells/components/menu/submenu/contest.erb";